import SignUpModal from './SignUpModal'

export default SignUpModal
